import Vue from "vue";
import CookieHelper from "@/helpers/CookieHelper";

const state = {
  uuid: "",
  first_name: "",
  last_name: "",
  address: "",
  city: "",
  zip_code: "",
  email: "",
  roles: [],
  card_barcode: "",
  gender: null,
  license_plate: null,
  license_plate_country_code: null,
  max_number_of_subscriptions: null,
  birth_date: null,
  phone_number: null,
  balance: 0,
  opt_in_newsletter: false,
  opt_in_promotion: false,
  opt_in_all_transactions: false,
  opt_in_topup: false,
  partial_iban: null,
  site_language: "nl_NL",
  confirmation_token: null,
  facebook_id: null,
  enabled: false,
  active_mandate: false,
  expects_invoices: false,
  anonymous_cards: [],
  is_b2b_customer: false,
  company_name: null,
  commercial_number: null,
  vat_number: null
};

const actions = {
  login(context, payload) {
    return Vue.prototype.$login_http.post("/api/login-check", payload);
  },
  register(context, payload) {
    return Vue.prototype.$http.post("/api/users/v1/register", payload);
  },
  async facebookLogin(context, payload) {
    try {
      await Vue.prototype.$http.post("/api/login/v1/facebook", payload);
    } catch (e) {
      return false;
    }
    return true;
  },
  async facebookConnect(context, payload) {
    return await Vue.prototype.$http.post("/api/facebook/v1/connect", payload);
  },
  user() {
    return Vue.prototype.$http.get("/api/users/v1");
  },

  update(context, payload) {
    return Vue.prototype.$http.put("/api/users/v1", payload);
  },
  delete() {
    return Vue.prototype.$http.delete("/api/users/v1");
  },
  addAnonymousCard(context, payload) {
    return Vue.prototype.$http
      .post("/api/anonymous-cards/v1", payload)
      .then(response => {
        context.state.anonymous_cards.push(response.data);
      });
  },
  deleteAnonymousCard(context, payload) {
    return Vue.prototype.$http
      .delete("/api/anonymous-cards/v1/" + payload.barcode, payload)
      .then(() => {
        context.state.anonymous_cards.splice(
          context.state.anonymous_cards.findIndex(item => {
            return item.barcode === payload.barcode;
          }),
          1
        );
      });
  },
  validateBarcode(context, payload) {
    return Vue.prototype.$http.get(
      "/api/registration/v1/validate-barcode/" +
        payload.type +
        "/" +
        payload.value
    );
  },
  validateEmail(context, payload) {
    return Vue.prototype.$http.post(
      "/api/registration/v1/validate-email",
      payload
    );
  },
  validateLicensePlate(context, payload) {
    return Vue.prototype.$http.post(
      "/api/registration/v1/validate-license-plate",
      payload
    );
  },
  getDataForUnsubscribe(context, payload) {
    return Vue.prototype.$http.get(
      "/api/unsubscribe/v1/" + payload.token,
      payload
    );
  },
  putUnsubscribeData(context, payload) {
    return Vue.prototype.$http.put(
      "/api/unsubscribe/v1/" + payload.token,
      payload.data
    );
  },
  resetPasswordRequest(context, payload) {
    return Vue.prototype.$http.post(
      "/api/resetting/v1/reset-password-request",
      payload
    );
  },
  resetPassword(context, payload) {
    return Vue.prototype.$http.post(
      "/api/resetting/v1/reset-password/" + payload.reset_token,
      {
        password: payload.password
      }
    );
  },
  getToken(context, payload) {
    return Vue.prototype.$http.post("/api/finish-login", payload);
  },
  validateResetPasswordToken(context, payload) {
    return Vue.prototype.$http.get(
      "/api/resetting/v1/validate-reset-password-token/" + payload
    );
  },
  confirmRegistration(context, payload) {
    return Vue.prototype.$http.get(
      "/api/registration/v1/confirm-registration/" + payload
    );
  },
  changeBankAccount(context) {
    const payload = {
      payment_provider_redirect_url:
        window.location.origin + "/mandate-payment-redirect"
    };
    return Vue.prototype.$http
      .post("/api/invoice-online-payment/v1/new-mandate", payload)
      .then(response => {
        context.commit("subscription/payment_id", response.data.payment_id, {
          root: true
        });
        context.commit("subscription/is_bank_account_change", true, {
          root: true
        });
        window.location.href = response.data.mollie_url;
      })
      .catch(() => {
        context.commit(
          "viewstate/notify",
          {
            text: Vue.prototype.$i18n.t("error.something_went_wrong"),
            color: "error"
          },
          { root: true }
        );
      });
  }
};

const mutations = {
  user(state, payload) {
    Object.keys(payload).forEach(key => {
      state[key] = payload[key];
    });
  },
  setFromCookie(state) {
    let cookie = CookieHelper.getUserCookie();
    Object.keys(cookie).forEach(key => {
      state[key] = cookie[key];
    });
  }
};

const getters = {
  user: state => {
    return state;
  },
  hasActiveMandate: state => {
    return state.active_mandate || false;
  },
  expectsInvoices: state => {
    return state.expects_invoices || false;
  }
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
